














































































import { Component, Vue } from "vue-property-decorator";
import BulkEmail from "./modals/bulkEmail.vue";
import Ajax from '../../lib/ajax';
import User from "@/store/entities/user";
import Advert from "@/store/entities/advert";
import Email from "@/store/entities/email";
@Component({
  components: { BulkEmail },
})

export default class AdUsers extends Vue {
  search: string = "";
  mockData:any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenModal: boolean = false;
    selected:any[]=[];
    adverts: Advert[] = [];




  
  async created() {

    (this.headers = [

      { text: "Ad & Soyad", value: "name" },
      { text: "E-posta", value: "email" },
      { text: "Telefon", value: "mobile" },

    ]),

    

      

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "İlan Kullanıcıları", disabled: true },
    ];
         await this.getAdsUsers();
    
  }

  async getAdsUsers(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetAdvertUsers'
      );
      var data = response.data.result.items;
      this.adverts=data;
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    
    };
  }

  truncateText(text) {
      if (text.length > 100) {
        return text.slice(0, 100) + '...';
      }
      return text;
    }
  

  cancelModal() {
    this.isOpenModal = false;

  }

 

  closeDialog() {
    this.$emit("closed");
  }


  openModal() {
    this.selected=this.adverts.filter(x=>x.selected);
    if(this.selected.length==0){
      this.$swal({
      title: "Kayıt Seçmediniz.",
      text: "Mail Göndermek İçin Seçim Yapmalısınız",
      icon: "error",
      showCancelButton: false,

    })
     return;
    }
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }


}
